import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Activity } from '@core/models/activity.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'xemex-activity-message-dialog',
  imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './activity-message-dialog.component.html',
})
export class ActivityMessageDialogComponent {
  readonly dialogRef = inject(MatDialogRef<ActivityMessageDialogComponent>);
  readonly data: { activity: Activity } = inject(MAT_DIALOG_DATA);

  get formattedMessage(): string {
    const msg = this.data.activity.message ?? '';
    try {
      return JSON.stringify(this.stripEmpty(JSON.parse(msg)), null, 2);
    } catch {
      return msg;
    }
  }

  private isEmptyValue(value: unknown): boolean {
    if (value === '' || value === null || value === undefined) return true;
    if (Array.isArray(value)) return value.length === 0;
    if (typeof value === 'object')
      return Object.keys(value as Record<string, unknown>).length === 0;
    return false;
  }

  private stripEmpty(value: unknown): unknown {
    if (Array.isArray(value)) {
      return value.map(v => this.stripEmpty(v));
    }
    if (value !== null && typeof value === 'object') {
      const result: Record<string, unknown> = {};
      for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
        const stripped = this.stripEmpty(v);
        if (!this.isEmptyValue(stripped)) result[k] = stripped;
      }
      return result;
    }
    return value;
  }
}
